module.exports = __webpack_public_path__ + "img/nhyh-Icon-144.3a7e46ef.png";